import React, {useEffect, useState} from 'react';
import './progress-bar.scss';

const ProgressBar = ({ percent }) => {

    const nbr = 10;
    //const [percentage, setPercentage] = useState(0);
    const [percentageList, setPercentageList] = useState([]);

    useEffect(() => {
        if (percent > 0) {
            let perRound = Math.round(percent / nbr);
            let percentageList = [];
            /*console.log(perRound);*/
            //setPercentage(perRound);
            for(let i = 0; i < perRound; i++) {
                percentageList.push(<span key={i}></span>);
            }
            setPercentageList(percentageList);
            /*console.log(percentageList);*/
        } else {
            /*setPercentage(0);*/
        }
    }, [percent]);

    const style = {
        width: `calc(${nbr}% - 4px)`,
    }

    return (
        <div className="progress-bar">
            <div className="progress-bar-inner">
                <div className={"progress-bar-inner-block " + (percent > 0 ? 'start' : '')}>
                    {
                        percentageList && percentageList.map((i) => {
                            return (
                                <span style={style} key={i}></span>
                            )
                        })
                    }
                </div>
                <div className="progress-bar-inner-text">
                    <p>{percent}%</p>
                </div>
            </div>
        </div>
    )
}

export default ProgressBar;
